import React from 'react';
import ProductCard from './ProductCard';
import './ProductGrid.css';

const ProductGrid = ({ title, products }) => {
  return (
    <section className="product-grid-section">
      {title && <h2 className="product-grid-title">{title}</h2>}
      
      {(!products || products.length === 0) ? (
        <p>No se encontraron productos.</p>
      ) : (
        <div className="product-grid-container">
          {products.map((product) => (
            <ProductCard key={product.id_product} product={product} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ProductGrid;